import React from 'react';
import { SupportedLocales } from '@cloudflare/intl-core'; // Default to en-US for consumers without a LocaleContext.Provider in their render tree

export default /*#__PURE__*/React.createContext(SupportedLocales['en_US']);